import classNames from 'classnames';
import { ClassName } from "types/ClassName";
import { FunctionComponent, ReactNode } from 'react';
import * as React from 'react';

export interface IOnboardingInformationPanelContentProps {
  headerText: string;
  bodyText: ReactNode;
  isTitle: boolean;
  onMouseDown?: (event: React.MouseEvent) => void;
  className?: ClassName;
}

const OnboardingInformationPanelContent: FunctionComponent<IOnboardingInformationPanelContentProps> = (props) => {
  const { headerText, bodyText, isTitle, onMouseDown, className } = props;

  const classes = classNames(
    {
      'onboarding-information-panel-content': true,
    },
    className
  );

  return (
    <div className={classes} onMouseDown={onMouseDown}>
      {isTitle ? <h2 className="fc-2">{headerText}</h2> : <div className="fw-semi-bold fc-2">{headerText}</div>}
      {isTitle ? <div className="mt-4">{bodyText}</div> : <div className="fc-2 mt-4">{bodyText}</div>}
    </div>
  );
};

export default OnboardingInformationPanelContent;
